import React from 'react';
import { makeStyles, TableRow, TableCell, Grid } from "@material-ui/core";
import TableCellEllipsis from '../../../shared/components/table/TableCellEllipsis';
import { SECONDARY_COLOR } from "../../../theme"
import { PlusCircle, Trash2 } from "react-feather";
import TableCellText from '../../../shared/components/table/TableCellText';

const LinhaAmostrasLote = ({
    item,
    index,
    handleClickIconeAcao,
    selecionandoAmostras
}) => {

    const classes = useStyles();

    const { id, codigo, tipoAmostra, tipoConservacao, numeroPedido, nomePaciente } = item

    return (
        <TableRow className={classes.linha} key={index + codigo} id={codigo}>
            <TableCellText text={codigo} />
            <TableCellEllipsis text={tipoAmostra?.descricao} width="200px" />
            <TableCellText text={tipoConservacao?.descricao} />
            <TableCellText text={numeroPedido} />
            <TableCellEllipsis text={nomePaciente} color="textPrimary" width="200px" />
            <TableCell>
                <Grid container direction="row" alignItems="center">
                    {selecionandoAmostras
                        ? <PlusCircle onClick={() => handleClickIconeAcao(id)} className={classes.iconeAcao} />
                        : <Trash2 onClick={() => handleClickIconeAcao(id, codigo)} className={classes.iconeAcao} />
                    }
                </Grid>
            </TableCell>
        </TableRow>
    );
}

const useStyles = makeStyles((theme) => ({
    iconeAcao: {
        cursor: "pointer",
        '&:hover': {
            color: SECONDARY_COLOR
        },
        height: "18px",
        width: "18px",
    },
    linha: {
        "& #form > div > div > div > div": {
            color: "#61688B",
        }
    },
}))

export default LinhaAmostrasLote;